import { Box, Button, Grid, TextField, MenuItem } from '@mui/material';
import { useEffect, useState } from 'react';

const CATEGORIAS = [
  'Servicios',
  'Alquiler',
  'Sueldos',
  'Transporte',
  'Impuestos',
  'Mantenimiento',
  'Otros'
];

const METODOS = ['Efectivo', 'Transferencia', 'QR', 'Tarjeta'];

export default function GastoForm({ onSubmit, editing }) {
  const [form, setForm] = useState({
    fecha: '',
    concepto: '',
    categoria: 'Otros',
    monto: '',
    metodoPago: 'Efectivo',
    observacion: ''
  });

  useEffect(() => {
    if (editing) setForm(editing);
  }, [editing]);

  const handleChange = e =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = () => {
    if (!form.monto || !form.concepto) {
      alert('Concepto y monto son obligatorios');
      return;
    }
    onSubmit(form);
    setForm({
      fecha: '',
      concepto: '',
      categoria: 'Otros',
      monto: '',
      metodoPago: 'Efectivo',
      observacion: ''
    });
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            type="date"
            label="Fecha"
            name="fecha"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={form.fecha}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Concepto"
            name="concepto"
            fullWidth
            value={form.concepto}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            select
            label="Categoría"
            name="categoria"
            fullWidth
            value={form.categoria}
            onChange={handleChange}
          >
            {CATEGORIAS.map(c => (
              <MenuItem key={c} value={c}>{c}</MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Monto"
            name="monto"
            type="number"
            fullWidth
            value={form.monto}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            select
            label="Método de Pago"
            name="metodoPago"
            fullWidth
            value={form.metodoPago}
            onChange={handleChange}
          >
            {METODOS.map(m => (
              <MenuItem key={m} value={m}>{m}</MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Observación (opcional)"
            name="observacion"
            fullWidth
            value={form.observacion}
            onChange={handleChange}
          />
        </Grid>
      </Grid>

      <Button
        fullWidth
        variant="contained"
        sx={{ mt: 2 }}
        onClick={handleSubmit}
      >
        {editing ? 'Actualizar Gasto' : 'Registrar Gasto'}
      </Button>
    </Box>
  );
}
